<template>
  <div class="products-topbar">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="topbar-search">
      <b-autocomplete
        v-model="storeSearch"
        :data="filteredStores"
        field="name"
        placeholder="Buscar loja..."
        clearable
        open-on-focus
        @select="onStoreSelect"
      >
        <template slot-scope="props">
          <div class="option-store">
            <span>{{ props.option.name }}</span>
          </div>
        </template>
        <template slot="empty">Nenhuma loja encontrada</template>
      </b-autocomplete>
    </div>

    <div class="topbar-actions">
      <button
        class="action-btn action-btn--primary"
        :disabled="!selectedStoreId"
        @click="search"
        title="Buscar produtos"
      >
        <b-icon icon="search" size="is-small" />
      </button>
      <button
        class="action-btn"
        :disabled="!selectedStoreId"
        @click="downloadProductsReport"
        title="Baixar relatório"
      >
        <b-icon icon="download" size="is-small" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      storeSearch: "",
      selectedStoreId: null,
      selectedStoreName: null
    };
  },

  computed: {
    ...mapGetters(["merchants"]),

    filteredStores() {
      const q = this.storeSearch.toLowerCase().trim();
      return this.merchants
        .flatMap(m =>
          (m.stores || []).map(s => ({
            name: s.storeInfo.name,
            storeId: s._id
          }))
        )
        .filter(s => !q || s.name.toLowerCase().includes(q))
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  },

  methods: {
    onStoreSelect(option) {
      if (!option) {
        this.selectedStoreId = null;
        this.selectedStoreName = null;
      } else {
        this.selectedStoreId = option.storeId;
        this.selectedStoreName = option.name;
      }
    },

    search() {
      if (!this.selectedStoreId) return;
      this.$emit("get-products", {
        storeId: this.selectedStoreId,
        storeName: this.selectedStoreName
      });
    },

    downloadProductsReport() {
      if (!this.selectedStoreId) return;
      this.isLoading = true;
      this.$store
        .dispatch("downloadProductsReport", {
          storeId: this.selectedStoreId,
          storeName: this.selectedStoreName
        })
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.alertReportDowloadMessage();
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>

<style scoped>
/* ── barra principal ── */
.products-topbar {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

/* ── busca de loja (cresce) ── */
.topbar-search {
  flex: 1 1 220px;
  min-width: 0;
}

.topbar-search ::v-deep .input {
  border-radius: 8px;
  border-color: #e0e0e0;
  font-size: 0.875rem;
  height: 38px;
}

/* ── botões de ação ── */
.topbar-actions {
  display: flex;
  gap: 0.35rem;
  flex-shrink: 0;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #fff;
  color: #555;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  outline: none;
}

.action-btn:hover:not(:disabled) {
  background: #fff4ee;
  border-color: #ff7034;
  color: #ff7034;
}

.action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.action-btn--primary {
  background: linear-gradient(135deg, #ff924c, #ff5c1a);
  border-color: transparent;
  color: #fff;
}

.action-btn--primary:hover:not(:disabled) {
  opacity: 0.9;
  background: linear-gradient(135deg, #ff924c, #ff5c1a);
  border-color: transparent;
  color: #fff;
}

/* ── opções do autocomplete ── */
.option-store {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* ── responsividade ── */
@media (max-width: 600px) {
  .topbar-search {
    flex: 1 1 100%;
  }
  .topbar-actions {
    flex-shrink: 0;
  }
}
</style>
